export default __webpack_public_path__ + "2879659ed28fed8996d7aa9fd5466534.png";